import { MEMBERSHIP_INFO } from "actions/types";
import { baseStore } from "../common/baseStore"

export default baseStore(MEMBERSHIP_INFO)
